import axios from 'axios';
import type { CLOTHESTYPE } from '../enums';

const BACKEND_URL = process.env.REACT_APP_API_URL;

axios.defaults.baseURL = BACKEND_URL;
axios.defaults.headers.common = {
  'Access-Control-Allow-Origin': '*',
  'Content-Type': 'application/json',
};

type Response = {
  error: boolean;
  message?: unknown;
  data?: unknown;
};

const getToken = (): string | undefined => {
  const tokenString = sessionStorage.getItem('token');
  const token = tokenString !== null ? atob(tokenString) : undefined;

  return token;
};

export class ClothingService {
  static async addClothingItem(clothingItem: {
    code: string;
    type: CLOTHESTYPE;
    name: string;
    department: string;
    firefighter?: string;
  }): Promise<Response> {
    const token = getToken();

    return new Promise((resolve) => {
      axios
        .post(
          '/v1/clothes',
          { ...clothingItem },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          resolve({ error: false, data: response.data });
        })
        .catch((error) => {
          resolve({ error: true, message: error });
        });
    });
  }

  static async getAllFireDepartmentClothes(departmentId: string): Promise<Response> {
    const token = getToken();

    return new Promise((resolve) => {
      axios
        .get(`/v1/clothes/department/${departmentId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          resolve({ error: false, data: response.data });
        })
        .catch((error) => {
          resolve({ error: true, message: error });
        });
    });
  }

  static async getClothingItemById(clothId: string): Promise<Response> {
    const token = getToken();

    return new Promise((resolve) => {
      axios
        .get(`/v1/clothes/${clothId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          resolve({ error: false, data: response.data });
        })
        .catch((error) => {
          resolve({ error: true, message: error });
        });
    });
  }

  static async assignClothingItemToMember(clothingItemId: string, memberId: string): Promise<Response> {
    const token = getToken();

    return new Promise((resolve) => {
      axios
        .put(
          '/v1/clothes/assign',
          { clothesId: clothingItemId, firefighterId: memberId },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          resolve({ error: false, data: response.data });
        })
        .catch((error) => {
          resolve({ error: true, message: error });
        });
    });
  }

  static async removeClothingItemFromMember(clothingItemId: string): Promise<Response> {
    const token = getToken();

    return new Promise((resolve) => {
      axios
        .put(
          '/v1/clothes/assign/remove',
          { clothesId: clothingItemId },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          resolve({ error: false, data: response.data });
        })
        .catch((error) => {
          resolve({ error: true, message: error });
        });
    });
  }
}
